import { render, staticRenderFns } from "./modalCadastroOrgao.vue?vue&type=template&id=d56eceaa"
import script from "./modalCadastroOrgao.vue?vue&type=script&lang=js"
export * from "./modalCadastroOrgao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports